module.exports = __webpack_public_path__ + "images/emoji/fallen_leaf.4c1520ea0993f05b38b3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fallen_leaf.png
// module id = 191n
// module chunks = 14